// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2StNt","inputDescription":"styles_inputDescription__12gZF"};